import APP_CONFIG from '@/appConfig';
import { DEFAULT_TENANT, TENANTS, TenantConfig } from './tenants';

/**
 * Resolves the active tenant.
 *
 * Order:
 * 1. `TENANT_OVERRIDE` env variable (forces a specific tenant id, e.g. for local development).
 * 2. Matched by `globalThis.location.hostname` containing `tenant.hostname`.
 * 3. Fallback to `DEFAULT_TENANT`.
 *
 * Not a React hook — tenant does not change at runtime, so no reactivity is needed.
 */
const getTenantConfig = (): TenantConfig => {
  const override = APP_CONFIG.tenantOverride;
  const hostname = globalThis.location.hostname;

  return (
    (override && TENANTS.find((t) => t.name === override)) ||
    TENANTS.find((t) => hostname.includes(t.hostname)) ||
    DEFAULT_TENANT
  );
};

export default getTenantConfig;
